import { useState, useEffect } from 'react'
import { get, ref } from "firebase/database";

import { formatDate, formatDate3 } from '../../utils/formatDates.js';
import { db } from '../../utils/firebaseApp.js';

export default function SubscriptionsDashboard({ usersInfo }) {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [history, setHistory] = useState([]);

    const [creditsTotal, setCreditsTotal] = useState(0);
    const [creditsToday, setCreditsToday] = useState(0);

    const [creditsChart, setCreditsChart] = useState([]);

    const [subscriptions, setSubscriptions] = useState([]);

    useEffect(() => {
        const fetchCredits = async () => {
            try {
                // Fetch all user billing data within the time range
                const billingRef = ref(db, 'userDetails');
                get(billingRef).then((snapshot) => {
                    if (snapshot.exists()) {
                        let data = snapshot.val();

                        let history = [];
                        let subscriptions = [];
                        Object.keys(data).forEach((userId) => {
                            console.log('userId', userId, data[userId]);
                            if (data[userId].credits) {
                                if (data[userId].credits.history) {
                                    Object.keys(data[userId].credits.history).forEach((historyKey) => {
                                        let element = data[userId].credits.history[historyKey];
                                        history.push({
                                            userId: userId,
                                            email: data[userId].email,
                                            credits: element.value,
                                            amount_total: element.stripeSession?.amount_total ?? 0,
                                            pages: element.pages,
                                            type: element.type,
                                            timestamp: element.timestamp
                                        });
                                    });
                                }

                                if (data[userId].credits.subscriptions) {
                                    Object.keys(data[userId].credits.subscriptions).forEach((subscriptionKey) => {
                                        let element = data[userId].credits.subscriptions[subscriptionKey];
                                        subscriptions.push({
                                            userId: userId,
                                            email: data[userId].email,
                                            subscription: element,
                                        });
                                    });
                                }
                            }
                        });

                        // sort the subscriptions by element.subscription.period.created
                        subscriptions.sort((a, b) => {
                            const dateA = new Date(a.subscription.period.created);
                            const dateB = new Date(b.subscription.period.created);
                            return dateB - dateA; // sort in descending order
                        });

                        setSubscriptions(subscriptions);

                        // sort history by timestamp
                        history.sort((a, b) => {
                            const dateA = new Date(a.timestamp);
                            const dateB = new Date(b.timestamp);
                            return dateB - dateA; // sort in descending order
                        });

                        // calculate total credits
                        let today = new Date();
                        let total = 0;
                        let todayCredits = 0;
                        history.forEach((element) => {
                            const date = new Date(element.timestamp);
                            if (date.getDate() === today.getDate() &&
                                date.getMonth() === today.getMonth() &&
                                date.getFullYear() === today.getFullYear()) {
                                todayCredits += element.amount_total;
                            }
                            total += element.amount_total;
                        });

                        // format credits to string, dollars, 2 decimals
                        total = (total / 100).toFixed(2);
                        todayCredits = (todayCredits / 100).toFixed(2);

                        setCreditsTotal(total);
                        setCreditsToday(todayCredits);

                        setHistory(history);
                        setLoading(false);

                        let creditsChart = [];

                        history.forEach(item => {
                            const timestamp = item.timestamp;
                            const day = formatDate(new Date(timestamp));
                            const newTimestamp = new Date(timestamp);

                            // Check if a credit entry for this day already exists
                            const existingEntry = creditsChart.find(entry => entry.day === day);

                            if (existingEntry) {
                                existingEntry.totalCredits += (item.amount_total / 100);
                            } else {
                                // Create a new entry for this day
                                const newEntry = {
                                    date: newTimestamp, // Store the actual Date object for sorting
                                    day: day,           // The formatted day string
                                    totalCredits: (item.amount_total / 100)
                                };

                                creditsChart.push(newEntry);
                            }
                        });

                        creditsChart.sort((a, b) => a.date - b.date);
                        creditsChart.forEach(entry => { entry.totalCredits = entry.totalCredits.toFixed(2) });

                        setCreditsChart(creditsChart);
                    }
                }).catch((error) => {
                    setError(error);
                    console.error('Error fetching user billing data', error);
                });

            } catch (error) {
                setError(error);
                console.error('Error fetching user billing data', error);
            }
        };

        fetchCredits();
    }, []);

    if (error) return <p>Error: {error.message}</p>;

    return (
        <div className="mt-4 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                    {/* <DataDisplayCredits today={creditsToday} total={creditsTotal} />
  
            <div className="mt-5 overflow-hidden rounded-lg bg-white px-4 py-5 sm:p-6 border">
              <dt className="truncate text-sm font-medium text-gray-500">Credits</dt>
              <dd className="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
                ${creditsTotal}
                <CreditsChart chartData={creditsChart} />
              </dd>
            </div>*/}

                    <div className='mb-5'></div>

                    <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                        <table className="min-w-full divide-y divide-gray-300">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                        Email
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        User Id
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        Plan
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        Period
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        Created
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        Status
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200 bg-white">
                                {subscriptions.map((element, index) => (
                                    <tr key={index}>
                                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                            {usersInfo[element.userId] ? usersInfo[element.userId].email : element.userId}
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                            {element.userId}
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                            {/* here if plan then show the price then show the number of pages */}
                                            {element.subscription.plan ? '$' + (element.subscription.plan.price / 100) + ' / ' + element.subscription.plan.pages + ' pages' : '-'}
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                            {/* if element.subscription.period is here, then show .startDate and .endDate. transform from date epoch to my format */}
                                            {element.subscription.period ? formatDate3(element.subscription.period.startDate) + ' - ' + formatDate3(element.subscription.period.endDate) : '-'}
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                            {element.subscription.period ? formatDate3(element.subscription.period.created) : '-'}
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                            {element.subscription.status ? element.subscription.status : '-'}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}